// extracted by mini-css-extract-plugin
module.exports = {"root":"PlanSwitcher_root__qzUSn","form":"PlanSwitcher_form__sTHiU"};